import { render, staticRenderFns } from "./CardFileFounder.vue?vue&type=template&id=083a9da2"
import script from "./CardFileFounder.vue?vue&type=script&lang=js"
export * from "./CardFileFounder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports